import { OnboardingHeader } from "@/features/registration/components/onboarding-header";

import { SessionRoomSystems } from "../sessions/room-systems";

export function RoomSystemsSettings() {
  return (
    <div>
      <OnboardingHeader
        title="Room Systems"
        description="View and manage room systems"
        className="mb-6"
      />
      <SessionRoomSystems />
    </div>
  );
}
